var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#646A82",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L3.29289 6.70708C2.90237 6.31655 2.90237 5.68339 3.29289 5.29286C3.68342 4.90234 4.31658 4.90234 4.70711 5.29286L8 8.58576L11.2929 5.29286C11.6834 4.90234 12.3166 4.90234 12.7071 5.29286C13.0976 5.68339 13.0976 6.31655 12.7071 6.70708L8.70711 10.7071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/Chevron-Down.7ed85d318c9958903c884395cca8bf68.svg";
export { ForwardRef as ReactComponent };